import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import { select, call } from 'redux-saga/effects';
import { isLoggedIn } from 'redux/saga/selectors';
import { userProfile } from 'redux/saga/entities/bound';

export default function* requireMembershipSaga(client, replaceState, validStatuses) {
  if (yield select(isLoggedIn)) {
    const profile = yield call(fetchEntityIfNeeded, userProfile, [client]);
    const { status } = profile.membership;
    if (validStatuses.indexOf(status) === -1) {
      return yield call(replaceState, '/');
    }
  }
}
